import React from 'react';
import Settings from './components/user_mqtt/Settings'
import AdminLoginComponent from './components/admin_mqtt/AdminLoginComponent'
import UserTokenComponent from './components/admin_mqtt/UserTokenComponent'
import TopicPubSubComponent from './components/admin_mqtt/TopicPubSubComponent';
import TopicLabelComponent from './components/admin_mqtt/TopicLabelComponent';
import { beforeConnecting, DisablesContext, SetDisablesContext } from './constant/UserMqtt';
import { Grommet, Accordion, AccordionPanel, Text, Box, Anchor} from 'grommet';
import PublishComponent from './components/user_mqtt/PublishComponent';
import SubscribeComponent from './components/user_mqtt/SubscribeComponent';
import ReceiveComponent from './components/user_mqtt/ReciveComponent';
import { AccordionPanelBoxStyle, AccordionBoxStyle, theme } from './constant/Styles';
import { Footer } from './components/Common';
import { DisabelesAdminContext, beforeConnectingForAdmin, SetDisablesAdminContext } from './constant/AdminMqtt';

const AccordionProps = (activeIndice: Array<number>, setActiveIndice: any, bgColor: string) => {
    return {
        activeIndex: activeIndice,
        multiple: true,
        background: bgColor,
        onActive: (activeIndice: Array<number>) => {
            setActiveIndice(activeIndice);
        }
    };
}

const AccordionPanelProps = (label: string) => {
    return {
        label: <Text size="large"><b>{label}</b></Text>,
    }
}

function StateMsg(msg: any){
    let displayMsg = JSON.stringify(msg);
    const state = displayMsg === '{}' ? "disconnected" : "connected";
    displayMsg = displayMsg === '{}' ?  '' : JSON.parse(displayMsg)['msg']
    return (
        <Box background="white">
            <Text textAlign="end" size="small">
                state：{state} {displayMsg} &ensp;|&ensp;
            </Text>
        </Box>
    );
}

const HeaderAnchorProps = (label: string, func: string) => {
    const URL = `/?${func}`;
    // const URL = window.location.hostname === "localhost" ? 
    //             "http://" + window.location.host + "/?" + func :
    //             "https://service.msgpub.net/?" + func;
    return {
        href: URL,
        label: label,
        target: "_blank",
        size: "small",
    };
}

function UserMqtt() {
    const [user, setUser] = React.useState();
    const [disables, setDisables] = React.useState(beforeConnecting);
    const [recv, setRecv] = React.useState("");
    const [logForPub, setLogForPub] = React.useState("");
    const [logForSub, setLogForSub] = React.useState("");
    const [aus, setAus] = React.useState();
    const [activeIndice, setActiveIndice] = React.useState([0]);

    return (
        <div>
            <Grommet theme={theme}>
                <Anchor {...HeaderAnchorProps("-> Open admin window", "admin") } style={{float: "right"}} />
                <StateMsg msg={aus}/>
                <Box {...AccordionBoxStyle}>
                    <DisablesContext.Provider value={disables}>
                        <Accordion {...AccordionProps(activeIndice, setActiveIndice, "neutral-3")}>
                            <AccordionPanel {...AccordionPanelProps("connect")} style={{height: "20px"}}>
                                <SetDisablesContext.Provider value={setDisables}>
                                    <Box {...AccordionPanelBoxStyle}>
                                        <Settings user={user} setUser={setUser} setAus={setAus} setActiveIndice={setActiveIndice}/>
                                    </Box>
                                </SetDisablesContext.Provider>
                            </AccordionPanel>
                            <AccordionPanel {...AccordionPanelProps("publish")} style={{height: "20px"}}>
                                <Box {...AccordionPanelBoxStyle}>
                                    <PublishComponent user={user} setRecv={setRecv} log={logForPub} setLog={setLogForPub} />
                                </Box>
                            </AccordionPanel>
                            <AccordionPanel {...AccordionPanelProps("subscribe")} style={{height: "20px"}}>
                                <Box {...AccordionPanelBoxStyle}>
                                    <SubscribeComponent user={user} setRecv={setRecv} log={logForSub} setLog={setLogForSub} />
                                </Box>
                            </AccordionPanel>
                            <AccordionPanel {...AccordionPanelProps("receive messages")} style={{height: "20px"}}>
                                <Box {...AccordionPanelBoxStyle}>
                                    <ReceiveComponent recv={recv} setRecv={setRecv}/>
                                </Box>
                            </AccordionPanel>
                        </Accordion>
                    </DisablesContext.Provider>
                </Box>
                <Footer/>
            </Grommet>
        </div>
    );

}

function AdminMqtt() {
    const [admin, setAdmin] = React.useState();
    const [disables, setDisables] = React.useState(beforeConnectingForAdmin);
    const [appForMsg, setAppForMsg] = React.useState();
    const [activeIndice, setActiveIndice] = React.useState([0]);

    return (
        <div>
            <Grommet theme={theme}>
                <Anchor {...HeaderAnchorProps("-> Open user window", "user")} style={{float: "right"}}/>
                <StateMsg msg={appForMsg} />
                    <Box {...AccordionBoxStyle}>
                        <DisabelesAdminContext.Provider value={disables}>
                        <Accordion {...AccordionProps(activeIndice, setActiveIndice, "status-warning")}>
                            <AccordionPanel {...AccordionPanelProps("connect")}>
                                <Box {...AccordionPanelBoxStyle}>
                                    <SetDisablesAdminContext.Provider value={setDisables}>
                                        <AdminLoginComponent admin={admin} setAdmin={setAdmin} setAppForMsg={setAppForMsg} setActiveIndice={setActiveIndice}/>
                                    </SetDisablesAdminContext.Provider>
                                </Box>
                            </AccordionPanel>
                                <AccordionPanel {...AccordionPanelProps("user and token management")}>
                                    <Box {...AccordionPanelBoxStyle}>
                                        <UserTokenComponent admin={admin}/>
                                    </Box>
                                </AccordionPanel>
                                <AccordionPanel {...AccordionPanelProps("topic management")}>
                                    <Box {...AccordionPanelBoxStyle}>
                                        <TopicPubSubComponent admin={admin}/>
                                    </Box>
                                </AccordionPanel>
                                <AccordionPanel {...AccordionPanelProps("label management")}>
                                    <Box {...AccordionPanelBoxStyle}>
                                        <TopicLabelComponent admin={admin}/>
                                    </Box>
                                </AccordionPanel>
                            </Accordion>
                        </DisabelesAdminContext.Provider>
                    </Box>
                <Footer/>
            </Grommet>
        </div>
    );
}

function App() {
    let query = window.location.search;
    if (query === '' || query === '?user') {
        document.title = 'user window';
        return (
            <UserMqtt/>
        );
    } else if (query === '?admin') {
        document.title = 'admin window';
        return (
            <AdminMqtt />
        );
    }

    return (<div/>);
}

export default App;
